export default __webpack_public_path__ + "static/media/reduceCost.134acdc1.svg";